export default __webpack_public_path__ + "media/zurb/img/home/revel-img-e365bd3372ee50378d50cb48739d8b4d.jpg";